/* unplugin-vue-components disabled */import script from "./packet.vue?vue&type=script&setup=true&lang=ts"
export * from "./packet.vue?vue&type=script&setup=true&lang=ts"

import "./packet.vue?vue&type=style&index=0&id=498a6a50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-498a6a50"]])

export default __exports__